export function GrainOverlay() {
  return <div className="grain" aria-hidden="true" />;
}
